var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"test-results"},[_c('div',{staticClass:"test-result-category"},[_c('h2',{staticClass:"title"},[_vm._v("Uitslag")]),_vm._v(" "),_c('p',{staticClass:"description"},[_c('design-2021-apprentice-radar-chart-component',{staticClass:"my-4",attrs:{"options":_vm.chartOptions,"series":_vm.series}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }